import React, { useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { APP_PREFIX_PATH } from 'configs/AppConfig';
import ListProduct from './ListProduct';
import './list.css'
import { useDispatch, useSelector } from 'react-redux';
import { getCategoryProducts, getProduct } from 'redux/actions';

function CategoryList({category, locale}) {

    const history = useHistory()
    const dispatch = useDispatch()

    const openItem = (id) => {
        // history.push(APP_PREFIX_PATH+'/products/'+id)
        // dispatch(getProduct(id))
    }
    
    return (
        <>
            <div className="d-flex my-1 py-2 justify-content-between align-items-center">
                <h3 className='m-0 productName text-black'>{locale==='en' ? category?.nameEng : category?.nameAr}</h3>
            </div>
            <div className=" mt-4 overflow-auto">
                {category?.products?.map(product => <Link to={APP_PREFIX_PATH+'/products/'+product?.id} key={product?.id} 
                    // style={{pointerEvents: product?.stock > 0 ? '' : 'none'}}
                >
                    <ListProduct product={product} locale={locale}/>
                </Link>)}
            </div>
        </>
    );
}

export default CategoryList;